/**
 * @file paddle hack register
 * @author wanzhongyun
 */

import React from 'react';
import { IHackRegister } from './../../type';

import './style.less';


const HackRegister: React.FC<IHackRegister> = props => {

    const {
        titleImageUrl,
        register,
        registerLink,
        joinCom,
        joinComLink
    } = props;
    
    return (
        <div className='paddle-hack-register-wrapper'>
            <div className='paddle-hack-registe-content'>
                <img className='paddle-hack-time-line-title' src={titleImageUrl} alt='' />
                <div className='paddle-hack-register-btn-wrapper'>
                    <a href={registerLink} target='_blank' rel='noreferrer'>
                        <div className='register-btn'>{register}</div>
                    </a>
                    <a href={joinComLink} target='_blank' rel='noreferrer'>
                        <div className='detail-btn'>{joinCom}</div>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default HackRegister;